import React, { useCallback, useEffect, useState } from 'react';
import { AccountDto } from '@/libs/api/account';
import LNImage, { ImageVariant } from '@/components/complex/ln-image';

import styles from './styles.module.scss';

interface Props {
  className?: string;
  size?: number;
  variant?: ImageVariant;
  account?: AccountDto;
  showBadge?: boolean;
  alt?: string;
}

const Avatar = (props: Props) => {
  const { className = '', account, size = 40, variant = 'original', alt } = props;
  const [downloadFailed, setDownloadFailed] = React.useState(false);
  const source = account?.profile?.url || '';

  const onError = useCallback(() => {
    setDownloadFailed(true);
  }, []);

  useEffect(() => {
    // URL 변경시 이미지를 다시 다운받도록 처리
    setDownloadFailed(false);
  }, [account?.profile?.url]);

  if (!account?.profile?.url || downloadFailed) {
    return <AvatarFallback {...props} />;
  }

  // alt가 명시되지 않으면 nickname/name으로 기본 alt를 생성한다.
  const ownerLabel = account?.nickname || account?.name;
  const resolvedAlt = alt ?? (ownerLabel ? `${ownerLabel} 프로필 이미지` : '');

  return <LNImage
    className={`${styles.root} ${className}`}
    source={source}
    variant={variant}
    alt={resolvedAlt}
    onError={onError}
    style={{
      width: size,
      height: size,
      minWidth: size,
      minHeight: size,
      borderRadius: size / 2,
    }} />;
};

const AvatarFallback = (props: Props) => {
  const { className = '', account, size = 40 } = props;
  const str = (account?.nickname || account?.name || 'X');
  const charactor = str.at(0) || 'X';
  const sizeString = `${size}px`;

  const theme = str
    .split('')
    .reduce((sum, ch) => sum + ch.charCodeAt(0), 0) % 4;

  return <div
    className={`${styles[`fallback-${theme}`]} ${className}`}
    style={{
      width: sizeString,
      height: sizeString,
      minWidth: sizeString,
      minHeight: sizeString,
      borderRadius: `${size / 2}px`,
      fontSize: `${size * 0.4}px`,
    }}>
    {charactor}
  </div>;
};

export default Avatar;